import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalService } from '@services/global.service';
import { RouteService } from '@services/route.service';
import { Product, Categ, SCateg, Gamme, Marque } from '@models/product';

@Component({
  selector: 'gob-ariane',
  templateUrl: './ariane.component.html',
  styleUrls: ['./ariane.component.scss']
})
export class ArianeComponent implements OnInit {
  _product: Product;
  @Input()
  set product(value: any){
    this._product=value;
    this.init();
  }

  get product(){
    return this._product;
  }

  categ: Categ;
  scateg: SCateg;
  gamme: Gamme;
  marque: Marque;

  constructor(private gServ: GlobalService, public route: RouteService) { }

  ngOnInit(): void {
  }

  init(){
    this.gServ.getCategs().subscribe(categs => this.categ=categs.filter(categ => categ.ident==this.product.categ)[0]);

    if(this.product.scateg)
      this.gServ.getSCategs().subscribe(scategs => this.scateg=scategs.filter(scateg => scateg.ident==this.product.scateg)[0]);

    if(this.product.gamme)
      this.gServ.getGammes().subscribe(gammes => this.gamme=gammes.filter(gamme => gamme.ident==this.product.gamme)[0]);

    if(this.product.marque)
      this.gServ.getMarques().subscribe(marques => this.marque=marques.filter(marque => marque.ident==this.product.marque)[0]);
  }

}
